<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Match #{{ matchDetail?.matchId }} – Details</h4>
      </div>
      <div class="modal-body">
        @if (isLoading) {
          <div class="text-center py-3">
            <span class="spinner-border spinner-border-sm"></span> Loading...
          </div>
        } @else if (matchDetail) {
          <dl class="row mb-3">
            <dt class="col-sm-4">State</dt>
            <dd class="col-sm-8">{{ MatchState[matchDetail.matchState] }}</dd>
            <dt class="col-sm-4">Cost</dt>
            <dd class="col-sm-8">{{ matchDetail.matchTableCost }}</dd>
            <dt class="col-sm-4">Start</dt>
            <dd class="col-sm-8">{{ matchDetail.matchStartTimestamp !== 0 ? dateService.getDateFromatted(matchDetail.matchStartTimestamp) : '-' }}</dd>
            <dt class="col-sm-4">End</dt>
            <dd class="col-sm-8">{{ matchDetail.matchEndTimestamp !== 0 ? dateService.getDateFromatted(matchDetail.matchEndTimestamp) : '-' }}</dd>
            <dt class="col-sm-4">Server ID</dt>
            <dd class="col-sm-8">{{ matchDetail.matchServerId ?? '-' }}</dd>
          </dl>

          <h6 class="mb-2">Players</h6>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>User ID</th>
                <th>Display Name</th>
                <th>Rank</th>
                <th>Score</th>
                <th>Ticket ID</th>
                <th>Player Session ID</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (matchDetail.users.length === 0) {
                <tr>
                  <td colspan="9" class="text-center text-muted">No players found.</td>
                </tr>
              } @else {
                @for (player of matchDetail.users; track player.userId; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td>{{ player.userId }}</td>
                    <td>{{ player.userDisplayname || 'Guest' + player.userId }}</td>
                    <td>{{ player.rank !== 0 ? player.rank : '-' }}</td>
                    <td>{{ player.score }}</td>
                    <td>{{ player.matchmakerTicketId || '-' }}</td>
                    <td>{{ player.matchmakerPlayerSessionId || '-' }}</td>
                    <td>
                      @if (player.isExited) {
                        <span class="badge bg-danger">Exited</span>
                      }
                    </td>
                    <td>
                      <a class="btn btn-sm btn-primary" routerLink="/backoffice/management/user-details" [queryParams]="{ id: player.userId }" target="_blank" tooltip="User details" placement="top"><i class="fa fa-search"></i></a>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>
